import React from 'react';
import { NoQuizz } from './NoQuizz';
import { QuizDef } from '../../types/quiz/quiz.def';
import Card from '../../components/molecules/Card';
import { green } from '../../theme/colors';
import { getDaysAndHoursLeft } from '../../helpers/date/formatDate';
import { GoToPage } from '../../helpers/page/goToPage';
import { ContainerFullWidth } from '../../components/layouts/ContainerFullWidth';
import { Divider } from '../../components/atoms/Dividers/Divider';
import useStyle from './quiz.style';
import pages from '../../routes/pages';

interface QuizzesViewProps {
  availableQuiz: QuizDef[];
  onNavigate: GoToPage;
}

const QuizzesView = ({ availableQuiz, onNavigate }: QuizzesViewProps) => {
  const classes = useStyle();
  if (!availableQuiz || availableQuiz.length === 0) return <NoQuizz />;

  return (
    <div className={classes.root}>
      <div className={classes.pageInfoText}>
        <h2 className={classes.pageTitle}>Quiz hebdomadaire</h2>
        <p className={classes.pageDesc}>
          Un seul essai possible - Du lundi 8h00 au dimanche 23h59 - Toutes les
          réponses dans : Challenge &gt; Réussir mes quiz's{' '}
          <span role="img" aria-label="emoji lunettes">
            😎
          </span>
        </p>
      </div>
      <ContainerFullWidth>
        <div className={classes.quizListWrapper}>
          {availableQuiz
            .filter(
              quiz =>
                !quiz.isAnsweredByUser &&
                getDaysAndHoursLeft(quiz.fin) !== 'Terminé'
            )
            .map(quiz => {
              const onClick = quiz.isAnsweredByUser
                ? onNavigate(pages.NOTE_PAGE.path)
                : () =>
                    onNavigate(pages.QUIZ_SINGLE_PAGE.path)({ id: quiz.id });

              return (
                <div key={quiz.id} className={classes.quizCard}>
                  <Card
                    labels={[
                      {
                        text: quiz.isAnsweredByUser ? 'Terminé' : 'Pas répondu',
                        backgroundColor: quiz.isAnsweredByUser
                          ? green
                          : '#DE8976',
                        icon: 'LabelTag'
                      },
                      {
                        text: getDaysAndHoursLeft(quiz.fin),
                        icon: 'Clock'
                      }
                    ]}
                    title={quiz.name}
                    desc={quiz.desc}
                    btns={[
                      {
                        text: quiz.isAnsweredByUser ? 'Résultat' : 'Commencer',
                        icon: quiz.isAnsweredByUser ? 'Form' : 'Play',
                        variant: quiz.isAnsweredByUser
                          ? 'primaryGreen'
                          : 'quizStart',
                        onClick
                      }
                    ]}
                  />
                </div>
              );
            })}
        </div>
      </ContainerFullWidth>
      <Divider />
      <ContainerFullWidth>
        <div className={classes.quizListWrapper}>
          {availableQuiz
            .filter(
              quiz =>
                quiz.isAnsweredByUser ||
                (!quiz.isAnsweredByUser &&
                  getDaysAndHoursLeft(quiz.fin) === 'Terminé')
            )
            .map(quiz => {
              const onClick = quiz.isAnsweredByUser
                ? onNavigate(pages.NOTE_PAGE.path)
                : null;

              return (
                <div key={quiz.id} className={classes.quizCard}>
                  <Card
                    labels={[
                      {
                        text: quiz.isAnsweredByUser ? 'Terminé' : 'Pas répondu',
                        backgroundColor: quiz.isAnsweredByUser
                          ? green
                          : '#DE8976',
                        icon: 'LabelTag'
                      },
                      {
                        text: getDaysAndHoursLeft(quiz.fin),
                        icon: 'Clock'
                      }
                    ]}
                    title={quiz.name}
                    desc={quiz.desc}
                    btns={[
                      {
                        text: quiz.isAnsweredByUser
                          ? 'Résultat'
                          : 'Résultats indisponibles',
                        icon: quiz.isAnsweredByUser ? 'Form' : null,
                        iconColor: quiz.isAnsweredByUser
                          ? '#000000'
                          : '#FFFFFF',
                        variant: quiz.isAnsweredByUser
                          ? 'primaryGreen'
                          : 'text',
                        onClick
                      }
                    ]}
                  />
                </div>
              );
            })}
        </div>
      </ContainerFullWidth>
    </div>
  );
};

export default QuizzesView;
